import { render, staticRenderFns } from "./PagingNavigator.vue?vue&type=template&id=1b0dd5e2&scoped=true&"
import script from "./PagingNavigator.vue?vue&type=script&lang=js&"
export * from "./PagingNavigator.vue?vue&type=script&lang=js&"
import style0 from "./PagingNavigator.vue?vue&type=style&index=0&id=1b0dd5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0dd5e2",
  null
  
)

export default component.exports